const toValidDate = (value) => {
  if (!value) {
    return null;
  }

  const resolved = value?.toDate?.() || value;
  const date = resolved instanceof Date ? resolved : new Date(resolved);
  return date instanceof Date && !Number.isNaN(date.getTime()) ? date : null;
};

export const getMoodSnapshotDayKey = (entry = {}) => {
  const date = toValidDate(entry.updatedAt || entry.timestamp || entry.createdAt || entry.date);
  return date ? date.toISOString().slice(0, 10) : null;
};

export const isMoodTimelineEntry = (entry = {}) => {
  const category = String(
    entry.category
    || entry.type
    || entry.timelineType
    || entry.actionType
    || entry.logCategory
    || entry.categoryId
    || entry.incidentCategoryId
    || ''
  ).toLowerCase();

  return category === 'mood';
};

export const isSameMoodSnapshot = (candidate = {}, moodEntry = {}) => {
  if (!candidate || !moodEntry) {
    return false;
  }

  if (candidate.childId !== moodEntry.childId) {
    return false;
  }

  if (!isMoodTimelineEntry(candidate) && candidate.actionType !== 'mood') {
    return false;
  }

  const candidateDayKey = getMoodSnapshotDayKey(candidate);
  const moodDayKey = getMoodSnapshotDayKey(moodEntry);

  return Boolean(candidateDayKey && moodDayKey && candidateDayKey === moodDayKey);
};

export const replaceMoodSnapshotInEntries = (entries = [], moodEntry = {}) => {
  const filteredEntries = entries.filter((entry) => !isSameMoodSnapshot(entry, moodEntry));
  return [moodEntry, ...filteredEntries].sort((a, b) => {
    const aDate = toValidDate(a?.updatedAt || a?.timestamp || a?.createdAt || a?.date) || new Date(0);
    const bDate = toValidDate(b?.updatedAt || b?.timestamp || b?.createdAt || b?.date) || new Date(0);
    return bDate - aDate;
  });
};

export const removeMoodSnapshotsFromEntries = (entries = [], moodEntry = {}) => (
  entries.filter((entry) => !isSameMoodSnapshot(entry, moodEntry))
);
